import { useReactiveVar } from "@apollo/client";
import { Navigate } from "react-router-dom";
import { ComponentLoading } from "../../components/loading/ComponentLoading";
import { userDetailsVar } from "../../lib/cache";
import { GamCampaignHomeHeader } from "./GamCampaignHomeHeader";
import { GamCampaignHomeSearchFilter } from "./GamCampaignHomeSearchFilter";
import { GamCampaignHomeBody } from "./GamCampaignHomeBody";

export const GamCampaignHomePage = () => {
    const currentUser = useReactiveVar(userDetailsVar);

    if (!currentUser) {
      return <ComponentLoading text={"Loading page..."} />;
    }

    if (
      !(currentUser?.isStaff || currentUser?.agency.partner)
    ) {
      return <Navigate to={"/"} />;
    }

    return (
      <>
        <GamCampaignHomeHeader />
        <GamCampaignHomeSearchFilter />
        <GamCampaignHomeBody />
      </>
    );
}
